export const USA = {
  name: "United States",
  code: "US"
};

export const COUNTRIES = [
  {
    value: "",
    label: "All Countries"
  },
  {
    value: USA.code,
    label: USA.name
  }
];
